import { render, staticRenderFns } from "./Recent.vue?vue&type=template&id=0725485e"
import script from "./Recent.vue?vue&type=script&lang=js"
export * from "./Recent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports